import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		isCollapse:false,
    menuList: [],
    userData: null,
	},
	getters: {
    menuList: (state, getters) => {
      console.log(state.menuList)
      return state.menuList
    },
	},
	mutations: {//self.$store.commit('setOpenid', self.myInfo.openid);
		setIsCollapse(state){
			state.isCollapse=!state.isCollapse
		},
    setMenuData(state, menuList) { //设置菜单
    	state.menuList = menuList
    },
    setUserData(state, userData) { //设置用户信息
    	state.userData = userData
    }
	},
	actions: {//self.$store.dispatch('getUserInfo', self.myInfo.openid);
		// lazy loading openid

	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js